/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { grey, dark, secondary } = colors.light;

export default {
  styleOverrides: {
    label: ({ theme }) => {
      const isDark = theme.palette.mode === "dark";
      return {
        marginTop: `${pxToRem(8)} !important`,
        fontWeight: fontWeightRegular,
        fontSize: size.regular,
        color: isDark ? "rgba(255,255,255,0.38)" : grey[300],

        "&.Mui-active": {
          fontWeight: `${fontWeightRegular} !important`,
          color: isDark ? "rgba(255,255,255,0.9) !important" : `${dark.main} !important`,
        },

        "&.Mui-completed": {
          fontWeight: `${fontWeightRegular} !important`,
          color: isDark ? "rgba(255,255,255,0.5) !important" : `${secondary.main} !important`,
        },
      };
    },
  },
};
